import { useEffect, useState } from 'react'
import styles from './style.module.css'
import { VisitedListComponent } from '../../components/VisitedListComponent/VisitedListComponent'
import { useSelector } from 'react-redux'
import { auth } from '../../firebase.config'
import { NavLink } from 'react-router-dom'
import { useNotifications } from '../../components/hooks/useNotifications'
import { useDataLoader } from '../../components/hooks/useDataLoader'
import { getVisitedPublicId } from '../../constans/functions/shareLinkServices'
import { ShareModal } from '../../components/ShareModal/ShareModal'

export const VisitedCountriesPage = () => {

  const visitedCountries = useSelector((state) => state.visitedList.visited);
  const isLoading = useSelector((state) => state.visitedList.isLoading);
  const { visitedNotification, handleVisitedClick } = useNotifications();
  const [isCopying, setIsCopying] = useState(false);
  const [modalShareOpen, setModalShareOpen] = useState(false);
  const [shareLink, setShareLink] = useState();

  const generateShareLink = async () => {
    try {
      setIsCopying(true);
      if (!auth.currentUser) {
        alert('Please sign in to share your list');
        return;
      }

      const publicId = await getVisitedPublicId(auth.currentUser.uid)

      if (publicId) {
        const baseUrl = window.location.origin;
        const shareLink = `${baseUrl}/shared/visitedlist/${publicId}`;
        setShareLink(shareLink);


      try {
        await navigator.clipboard.writeText(shareLink);
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
        setModalShareOpen(true);
      } else {
        alert('Error generating share link');
      }

    } catch (err) {
      console.error('Error generating share link:', err);
      alert('Error generating share link');
    } finally {
      setIsCopying(false);
    }
  };

  useEffect(() => {
    if (visitedNotification) {
      handleVisitedClick();
    }
  }, [visitedNotification, handleVisitedClick]);
  
  useDataLoader();
  
  const userName = () => {
      if (auth.currentUser && auth.currentUser.displayName) {
        return auth.currentUser.displayName
      } else {
        return 'Guest'
      }
    }
  
    if (isLoading) {
      return (
        <div>
          <h1 className={styles.h1}>Loading list of your visited countries...</h1>
        </div>
      );
    }

  const greetings = () => {
    
    if (isLoading) {
      return (
        <div>
          <h1 className={styles.h1}>Loading list of your visited countries...</h1>
        </div>
      );
    }
    if (visitedCountries.length === 0) {
      return (
        <div>
          <h1 className={styles.h1}>{ 
            'Your journey starts here! 🌍'}
          </h1>
            <h2 className={styles.h2}>
             Start planning your first trip and mark your first visited country 📍
            </h2>
             <div className={styles.links_container}>
                <NavLink className={`${styles.link_to_countries} ${styles.link_to_names}`} to='/allnames'>Countries <br /> by names</NavLink>
                <NavLink className={`${styles.link_to_countries} ${styles.link_to_flags}`} to='/allflags'>Countries <br /> by flags</NavLink>
              </div>
        </div>
      )
    } else if (visitedCountries.length === 1) {
      return (
        <div>
          <h1 className={styles.h1}>
            {userName()}, you've been {' '}
              <br className={styles.mobileBreak} />
            to {visitedCountries.length} country!
          </h1>
          <h2 className={styles.h2}>
              What's next on your journey? 🗺️</h2>
          <div className={styles.button_container}>
            <button 
              className={styles.share_button}
              onClick={generateShareLink}
              disabled={isCopying}>
              <div className={styles.plane_icon}>
                  <svg width="64" height="64" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                  </svg>
              </div>
              Share your achievement
              <div className={styles.arrow_icon}>→</div>
            </button>
          </div>
        </div>
      )
    } else {
      return (
      <div>
          <h1 className={styles.h1}>
            {userName()}, you've been {' '}
              <br className={styles.mobileBreak} />
            to {visitedCountries.length} countries!
          </h1>
          <h2 className={styles.h2}>
              What's next on your journey? 🗺️</h2>
          <div className={styles.button_container}>
            <button 
              className={styles.share_button}
              onClick={generateShareLink}
              disabled={isCopying}>
              <div className={styles.plane_icon}>
                <svg width="64" height="64" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                </svg>
              </div>
              Share your travel story
              <div className={styles.arrow_icon}>→</div>
            </button>
          </div>
        </div>
      )
    }
  }

  return (
     <div className={styles.root}>
         <div className={styles.greetings}> 
          {greetings()}
         </div>
          <VisitedListComponent isShared={false}/>    
          
          <ShareModal
          isOpen={modalShareOpen} //modalShareOpen
          onClose={() => {setModalShareOpen(false)}}
          listName={'visited'}
          shareLink={shareLink}>
          </ShareModal>
          <footer className={styles.footer}>
            <div className={styles.footer_content}>
              <h1 className={styles.seo_text_h1}>Your travel map</h1>
              <h2 className={styles.seo_text}>
                Show the world where you've been! Share this list on social media <br />or send it directly to friends.
                <br />
                <br />Made a mistake? Just click the "edit" button to fix it.
                <br />
                <br />There are still so many countries waiting for you. Keep exploring!
                <br />
                <br />More countries <NavLink className={styles.names_link} to={'/allflags'}>here</NavLink>.
              </h2>
            </div>
          </footer>
        </div>
  )
}